import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface FeeTypeDTO {
  id?: number;
  name: string;
  description?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface FeeTypeRequestDTO {
  name: string;
  description?: string;
}

export interface ApiResponse<T> {
  data: T;
  isSuccess: boolean;
  message?: string;
}

@Injectable({
  providedIn: 'root'
})
export class FeeTypesService {
  private readonly baseUrl = `${environment.apiUrl}/FeeTypes`;

  constructor(private http: HttpClient) { }

  /**
   * Obtiene todos los tipos de comisión
   */
  getAll(): Observable<ApiResponse<FeeTypeDTO[]>> {
    return this.http.get<ApiResponse<FeeTypeDTO[]>>(this.baseUrl);
  }

  /**
   * Obtiene un tipo de comisión por ID
   */
  getById(id: number): Observable<ApiResponse<FeeTypeDTO>> {
    return this.http.get<ApiResponse<FeeTypeDTO>>(`${this.baseUrl}/${id}`);
  }

  /**
   * Crea un nuevo tipo de comisión
   */
  insert(feeType: FeeTypeRequestDTO): Observable<ApiResponse<FeeTypeDTO>> {
    return this.http.post<ApiResponse<FeeTypeDTO>>(this.baseUrl, feeType);
  }

  /**
   * Actualiza un tipo de comisión existente
   */
  update(id: number, feeType: FeeTypeRequestDTO): Observable<ApiResponse<FeeTypeDTO>> {
    return this.http.put<ApiResponse<FeeTypeDTO>>(`${this.baseUrl}/${id}`, feeType);
  }

  /**
   * Elimina un tipo de comisión
   */
  delete(id: number): Observable<ApiResponse<boolean>> {
    return this.http.delete<ApiResponse<boolean>>(`${this.baseUrl}/${id}`);
  }
}